import { ComplianceCaseTypeEnum } from "~/graphql/supergraphEnums";

export const CURRENT_CASE_ROW_CLASS = "current-crs-case-row";

export const POSITION_CASE_TYPES = [
  ComplianceCaseTypeEnum.InvestorOnboarding,
  ComplianceCaseTypeEnum.Remediation,
  ComplianceCaseTypeEnum.ProfileRefresh,
  ComplianceCaseTypeEnum.ChangeInCircumstance,
  ComplianceCaseTypeEnum.DocumentRefresh,
] as const;
